import { memo, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "../../../shared/helpers/toast";
import { cdnLogin } from "../../conf";

const EntryPoint = withRouter(({ changeConfigChildRoute, error: { showError, status, key }, history }) => {
    const { t } = useTranslation("notification");

    useEffect(() => {
        if (showError) {
            try {
                let statusNumber = {};

                if (typeof status === "object" && (status.hasOwnProperty("response") || status.hasOwnProperty("request"))) {
                    const { response, request } = status;
                    statusNumber = Number.isInteger(status) ? status : response ? response.status : request.status;
                } else {
                    statusNumber = status;
                }

                switch (statusNumber) {
                    case 201:
                    case 200:
                        if (key) {
                            toast(t(key));
                        }
                        break;
                    case 403:
                        localStorage.clear();
                        sessionStorage.clear();
                        changeConfigChildRoute();
                        toast(t("without_authorization"));
                        window.location.href = cdnLogin;
                        break;
                    case 401:
                        localStorage.clear();
                        sessionStorage.clear();
                        changeConfigChildRoute();
                        toast(t("without_authorization"));
                        window.location.href = cdnLogin;
                        break;
                    case 409:
                        if (key) {
                            toast(t(key));
                        } else {
                            toast(`${t("error_ocurred")}, ${t("try_again_later")}`, 500);
                        }
                        break;
                    default:
                        if (status.message && status.message.key) {
                            toast(t(status.message.key));
                        } else {
                            toast(`${t("error_ocurred")}, ${t("try_again_later")}`, 500);
                        }
                        break;
                }
            } catch (err) {
                console.error(err);
            }
        }
    }, [showError, status, key, history, changeConfigChildRoute, t]);

    return null;
});

export default memo(EntryPoint);
